import { FC } from 'react'
import { Title, FormFieldRequired, Divider } from '../../'

type FormTitleProps = {
  className?: string,
  component?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',
  color?: string,
  size?: string,
  required?: boolean,
  divider?: boolean
}

const FormTitle:FC<FormTitleProps> = ({ className, children, component = 'h2', color = '', size, required = false, divider = true }) => {
  return (
    <>
      <Title component={required ? 'h2' : component} size={required ? '12' : size} color={required ? '' : color ? color : 'primary'} weight={required ? 'default' : 'semibold'} className={className}>{required ? <FormFieldRequired /> : ''} {children}</Title>
      {divider && <Divider className="mt-5" />}
    </>
  )
}

export { FormTitle }